// extracted by mini-css-extract-plugin
export default {"icon":"Operator_icon__6wizN","text":"Operator_text__5ttee"};